export default "__VITE_ASSET__C6GL7OVB__"